// ─────────────────────────────────────────────────────────────────────────────
// ChartCard.js — the fixed-height glass card each chart sits in, plus the
// loading / "No data" body it falls back to.
//
// The card owns the label and the height so both charts agree on them; the
// chart owns only its plot. `ChartPlaceholder` deliberately keeps the same
// label row as a loaded chart, so nothing shifts when data lands.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./ChartCard.module.css";

export default function ChartCard({ children }) {
  return <div className={styles.card}>{children}</div>;
}

/** The label + plot column shared by LineChart, BarChart and the placeholder. */
export function ChartBody({ label, children }) {
  return (
    <div className={styles.wrap}>
      <div className={styles.label}>{label}</div>
      {children}
    </div>
  );
}

/**
 * Shown while a chart's data is in flight, or once it has arrived with nothing
 * plottable in it. The two are different claims, so they read differently.
 */
export function ChartPlaceholder({ label, loading }) {
  return (
    <ChartBody label={label}>
      <div className={styles.placeholder}>
        {loading ? <span className={styles.loadingText}>Loading…</span> : "No data"}
      </div>
    </ChartBody>
  );
}
